export default function setBodyColor({color}) {
  document.documentElement.style.setProperty('--bodyBackground', color);
}